module.exports = __webpack_public_path__ + "static/10-6e2d666fa09c2718d21b48bf05078ac7.jpg";